<form [formGroup]="selecting" class="grid gap-6 mb-5">
  <div>
    <label>
      <xena-button (click)="fileInput.click()" i18n="@@import_csv_file_select_import">Import csv file</xena-button>
      <input #fileInput type="file" (change)="onFileSelected($event)">
    </label>
    <span class="ml-3">{{ selecting.get('file').value?.name }}</span>
  </div>
  <div>
    <xena-autocomplete
      idProperty="id"
      i18n-label="@@import_csv_default_costType"
      label="Default cost type"
      [datasource]="getCostTypeListDatasource"
      formControlName="defaultCostType"
      listLabelProperty="description"
      valueLabelProperty="description"
      debounce="300"
      show-initial-no-result="false"
      no-result-text="No results"
      i18n-no-result-text="@@import_csv_cost_type_noResult" hoist>
      <span slot="error-text" *ngIf="selecting.get('defaultCostType').touched && selecting.get('defaultCostType').invalid" i18n="@@import_csv_cost_type_required">Cost type required</span>
    </xena-autocomplete>
  </div>
</form>
